import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Navigation from './Navigation'
import ButtonHex from './ButtonHex'
import '../styles/header.css'

class Header extends Component {
  constructor () {
    super()
    this.state = {
      navActive: false
    }
  }

  setGoogleMap () {
    let map = new window.google.maps.Map(document.getElementById('google-map'), {
      center: {lat: 52.685200, lng: -2.424553},
      zoom: 18,
      mapTypeId: 'satellite'
    })
    let info = '<i class="ac ac-buildings"></i>' +
    '<div class="iw-content">Bronze Software Labs<br>e-Innovation Centre,<br>Priorslee,<br>Telford,<br>Shropshire.<br>TF2 9FT</div>' +
    '<div class="clearall"></div>' +
    '<i class="ac ac-smartphone"></i>' +
    '<a class="iw-content link" href="tel:+441952288215" rel="noopener">+44(0)1952 288 215</a>' +
    '<div class="clearall"></div>' +
    '<i class="ac ac-mail"></i>' +
    '<a class="iw-content link" href="mailto:info@bronzelabs.co.uk" rel="noopener">info@bronzelabs.co.uk</a>'
    let infowindow = new window.google.maps.InfoWindow({
      content: info,
      maxWidth: 300
    })
    let marker = new window.google.maps.Marker({
      position: {lat: 52.684389, lng: -2.424553},
      icon: 'images/marker.png',
      map: map
    })
    window.google.maps.event.addListener(marker, 'click', function () {
      infowindow.open(map, marker)
    })
    window.google.maps.event.addListener(map, 'click', function () {
      infowindow.close()
    })
    window.google.maps.event.trigger(marker, 'click')
  }

  toggleNavigation () {
    this.setState({navActive: !this.state.navActive})
    this.setGoogleMap()
  }

  checkActive () {
    const container = document.querySelector('.mainContainer')
    if (container != null) {
      if (this.state.navActive) {
        setTimeout(() => {
          // double check they haven't close menu already
          if (this.state.navActive) {
            container.classList.add('noHeight')
          }
        }, 400)
      } else {
        container.classList.remove('noHeight')
      }
    }
  }

  render () {
    const { history } = this.props
    const { navActive } = this.state
    const back = (e) => {
      e.stopPropagation()
      history.goBack()
    }

    this.checkActive()

    return (
      <header className={(this.props.modal ? 'modal' : '') + (navActive ? ' active' : '')}>
        <ButtonHex id='navButton' onClick={(e) => { (this.props.modal) ? back(e) : this.toggleNavigation() }} />
        <div className='logo'>
          <Link to='/'>
            <div className='icon ac ac-bronzelabs' />
            <div className='text'>
              <div className='bold'>bronze</div>
              <div className='light'>labs.</div>
            </div>
          </Link>
        </div>
        <Navigation active={navActive} toggleNavigation={() => this.toggleNavigation()} />
        <span>
          <div className='transitionAnimation' />
          <div className='transitionMask' />
        </span>
      </header>
    )
  }
}

Header.propTypes = {
  history: PropTypes.object,
  modal: PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js